// extracted by mini-css-extract-plugin
export default {"navbar":"nav_navbar__B+AvG","left":"nav_left__zMp2X","mid":"nav_mid__M0hZr"};